import { Component, OnInit } from '@angular/core';
import { BookingService } from "../../../shared/services/booking.service";
import { NzMessageService } from 'ng-zorro-antd/message';
import { BehaviorSubject, Subscription } from 'rxjs';
interface MyObject { // define the object (singular)
  id: number;
  name: string;
}

@Component({
  selector: 'app-working-days-time',
  templateUrl: './working-days-time.component.html',
  styleUrls: ['./working-days-time.component.scss']
})
export class WorkingDaysTimeComponent implements OnInit {
  date:any;
  isAddTimeVisible: boolean = false;
  isAddDayTimeVisible: boolean = false;
  isWoringDayLoading = false;
  isConfirmLoading: boolean = false;
  WoringDayList = [];
  list: any[] = [];
  time: Date;
  defaultOpenValue = new Date(0, 0, 0, 0, 0, 0);
  selectedDate: any;
  listOfDay = [];
  TimeChecked: string[] = [];
  listOfTime = [
    {
      id: 1,
      time: "16:00:00",
      checked: false,
    },
    {
      id: 2,
      time: "17:00:00",
      checked: false,
    },
    {
      id: 3,
      time: "18:00:00",
      checked: false,
    },
    {
      id: 4,
      time: "19:00:00",
      checked: false,
    },
    {
      id: 5,
      time: "20:00:00",
      checked: false,
    },
    {
      id: 6,
      time: "21:00:00",
      checked: false,
    },
    {
      id: 7,
      time: "22:00:00",
      checked: false,
    },
    {
      id: 8,
      time: "23:00:00",
      checked: false,
    },
    {
      id: 9,
      time: "00:00:00",
      checked: false,
    }
  ];
  constructor(public bookingService: BookingService,
    private message: NzMessageService) { }

  ngOnInit(): void {

    this.getWorkingDays();



  }


  showAddTimeModal(id: any): void {
    this.TimeChecked=[];
    this.selectedDate= id;
    this.DayId = id;
   this.getTimeByDayIdRow(this.selectedDate);
   console.log("1")
    this.isAddTimeVisible = true;
  }

  handleAddTimeOk(): void {
    this.isAddTimeVisible = false;
  }

  handleAddTimeCancel(): void {
    this.isAddTimeVisible = false;
  }



  showAddDayTimeModal(): void {
    this.TimeChecked = [];
    this.CheckboxTimeList = [];
    this.TimeListByDayId = [];
  
    this.isAddDayTimeVisible = true;
  }

  handleAddDayTimeCancel(): void {
    this.TimeChecked = [];
    this.isAddDayTimeVisible = false;
  }



  async getWorkingDays() {

    let params = {
      pageSize: 10,
      page: 1
    }
    this.isWoringDayLoading = true;
    this.bookingService.getWorkingDays(params).subscribe(
      (response: any) => {
        this.WoringDayList = response?.data;
        this.isWoringDayLoading = false;
        const result = this.WoringDayList.filter((obj) => {
          return obj['is_added'] === false;
        });
        this.listOfDay = result;
      },
      (err) => {
        this.isWoringDayLoading = false;
      }
    );


  }
  TimeListByDayId: any = [];
  isWoringDayIDLoading = false;





  async deleteDays(id: any) {
    this.isWoringDayLoading = true;
    this.bookingService.DeleteWorkingDays(id).subscribe({
      next: (response: any) => {
        this.TimeChecked = [];
        this.isWoringDayLoading = false;
        this.getWorkingDays();
      },
      error: (error) => {
        this.isWoringDayLoading = false;
      }
    }
    );

  }




  DayId: number;
  addTimeToDay() {
    var Hours = (this.time.getHours() < 10 ? '0' : '') + this.time.getHours();
    var Minutes = (this.time.getMinutes() < 10 ? '0' : '') + this.time.getMinutes();
    var Seconds = (this.time.getSeconds() < 10 ? '0' : '') + this.time.getSeconds();
    var time = Hours + ":" + Minutes + ":" + Seconds;
    let params = {
      "working_day": this.DayId,
      "time": time.toString(),
    }
    this.bookingService.addTimeToDay(params).subscribe({
      next: (response: any) => {
        this.isWoringDayLoading = false;
        this.getWorkingDays();
        this.TimeChecked = [];
        this.selectedDate = null;
        this.message.success(response.description, {
          nzDuration: 3000,
          nzAnimate: true,
        });
        this.isAddTimeVisible = false;
      },
      error: (error) => {
        this.isWoringDayLoading = false;
        this.isAddTimeVisible = false;
        this.message.error(error.error.description, {
          nzDuration: 3000,
          nzAnimate: true,
        });
      }
    }
    );


  }

  
  
  
  
  NewSelectedTimeCheckedRow =[];
  changeCheckboxTimeRow(listOfTime: any) {
    if(listOfTime['is_added'] == true){
      this.NewSelectedTimeCheckedRow.push(listOfTime['time']);
  
    }else{
      this.removeVal(this.NewSelectedTimeCheckedRow, listOfTime['time']);
    }
  }

  removeVal(arr: any, val: any) {
    console.log( this.NewSelectedTimeCheckedRow)
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == val)
        arr.splice(i, 1);
    }
  }

  async addNewTime() {
    console.log("5")
    let params = {
      "payload": [
        {
          "number": parseFloat(this.selectedDate),
          "times": this.NewSelectedTimeCheckedRow,
        }
      ]
    }
    this.isWoringDayLoading = true;

    this.bookingService.addDateTime(params).subscribe({
      next: (response: any) => {
        this.isAddDayTimeVisible = false;
        this.isAddTimeVisible = false;
        this.isWoringDayLoading = false;
        this.getWorkingDays();
        this.TimeListByDayIdRow = [];
        this.NewSelectedTimeCheckedRow = [];
        this.TimeCheckedRow = [];
        this.selectedDate = null;
        this.message.success(response.description, {
          nzDuration: 3000,
          nzAnimate: true,
        });
      },
      error: (error) => {
        this.isWoringDayLoading = false;
        this.isAddDayTimeVisible = false;
        this.isAddTimeVisible = false;
        this.message.error(error.error.description, {
          nzDuration: 3000,
          nzAnimate: true,
        });
      }
    })
  }






  TimeListByDayIdRow =[];
  TimeCheckedRow=[];
  async getTimeByDayIdRow(id) {
    this.TimeListByDayIdRow =[];
    this.TimeCheckedRow=[];
    this.isWoringDayIDLoading = true;
    this.bookingService.getTimeByDayId(id).subscribe(
      (response: any) => {
   
        console.log("2")
        this.TimeListByDayIdRow = response?.data['times'];
          var result = this.TimeListByDayIdRow
          for(var i = 0 ; i < result.length;i++ ){
            this.TimeCheckedRow.push(result[i]['time']);
            if(result[i]['is_added'] == true){
              console.log(result[i]['time'])
              this.NewSelectedTimeCheckedRow.push(result[i]['time']);
          
            }
          }

          
        this.isWoringDayIDLoading = false;

      },
      (err) => {
        this.isWoringDayIDLoading = false;
      }
    );


  }











// //////////////////////////////////////////////////////////////////////////
  
  CheckboxTimeList:any=[];

  changeSelectedDate(event: Event) {
    this.getTimeByDayId();
    console.log("1")
  }

  async getTimeByDayId() {
    this.isWoringDayIDLoading = true;
    this.bookingService.getTimeByDayId(this.selectedDate).subscribe(
      (response: any) => {
        console.log("2")
        this.TimeListByDayId = response?.data['times'];
        console.log(" this.TimeListByDayId ")
        console.log( this.TimeListByDayId )
          //  const result = this.TimeListByDayId.filter(x => x == code => {
          //   return obj['is_added'] === true;
          //  });
          //  var result = this.TimeListByDayId.filter((x: { [x: string]: boolean; }) => x['is_added'] == true);
          var result = this.TimeListByDayId
          for(var i = 0 ; i < result.length;i++ ){
            this.TimeChecked.push(result[i]['time']);
          }
          console.log("result")
          console.log(result)

        console.log(this.TimeChecked)
        this.isWoringDayIDLoading = false;

      },
      (err) => {
        this.isWoringDayIDLoading = false;
      }
    );


  }


  async addDayAndTime() {
    console.log("5")
    let params = {
      "payload": [
        {
          "number": parseFloat(this.selectedDate),
          "times": this.CheckboxTimeList,
        }
      ]
    }
    this.isWoringDayLoading = true;

    this.bookingService.addDateTime(params).subscribe({
      next: (response: any) => {
        this.isAddDayTimeVisible = false;
        this.isAddTimeVisible = false;
        this.isWoringDayLoading = false;
        this.getWorkingDays();
        this.TimeChecked = [];
        this.selectedDate = null;
        this.message.success(response.description, {
          nzDuration: 3000,
          nzAnimate: true,
        });
      },
      error: (error) => {
        this.isWoringDayLoading = false;
        this.isAddDayTimeVisible = false;
        this.isAddTimeVisible = false;
        this.message.error(error.error.description, {
          nzDuration: 3000,
          nzAnimate: true,
        });
      }
    })
  }



   AddCheckboxTime(listOfTime: any) {
    console.log("3")
    if(listOfTime['is_added'] == true){
      this.CheckboxTimeList.push(listOfTime['time']);
    }else{
      this.removeTimeFromList(this.CheckboxTimeList, listOfTime['time']);
    }
  
  console.log(this.CheckboxTimeList);
  }


  removeTimeFromList(arr: any, val: any) {
    console.log("4")
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == val)
        arr.splice(i, 1);
    }
  }


}
